export default function findCursor(editor, cursorType) {
  var cursor = editor.value.document.findDescendant(function (node) {
    return node.type === cursorType;
  });
  var block, offset;

  if (cursor) {
    block = editor.value.document.getClosestBlock(cursor.key);
    offset = block.getOffset(cursor.key);
    editor.removeNodeByKey(cursor.key);
  }

  return {
    block: block,
    offset: offset
  };
}